export default __webpack_public_path__ + "static/media/button.3b514a5e.jpg";